import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import DialogTitle from 'components/DialogTitle/styles';
import DialogContainer from 'components/DialogContainer/styles';
import {ButtonOutline} from 'components/buttons';
import DialogBody from 'components/DialogBody/styles';
import {OPEN_ADJUST_SUCCESS_MODAL} from 'store/ordersV2/orderAdjust/action';
import DialogAction from 'components/DialogAction/styles';
import DialogActions from 'components/DialogActions/styles';
import {DialogSubTitle} from 'components/DialogSubTitle/styles';
import {ORDER, ORDER_SOURCE} from 'helpers/constants/orders_v2';

const AdjustSuccessModal = ({isOpen}) => {
  const dispatch = useDispatch();
  const order = useSelector((state) => state.orderDetailsV2Reducer.order);
  const isGrubHubAdjust = order[ORDER.SOURCE] === ORDER_SOURCE.GRUBHUB;
  return (
    <Dialog open={isOpen}>
      <DialogContainer className='DialogSm Overflow'>
        <DialogTitle className='DialogTitleMarginBottom'>
          {isGrubHubAdjust
            ? 'Order adjustment has been requested.'
            : 'Order price has been updated'}
        </DialogTitle>
        {isGrubHubAdjust ? (
          <DialogSubTitle className='textCenter mBottomLarge'>
            We will update the order once adjustment is confirmed by GrubHub
          </DialogSubTitle>
        ) : null}
        <DialogBody>
          <DialogActions className='justifyCenter'>
            <DialogAction className='w50'>
              <ButtonOutline
                onClick={() => dispatch(OPEN_ADJUST_SUCCESS_MODAL(false))}
              >
                <span>Ok</span>
              </ButtonOutline>
            </DialogAction>
          </DialogActions>
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
};

AdjustSuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired
};
export default AdjustSuccessModal;
